<template>
<div class="topAsideContainer">
  <div class="left">
    <div class="logo">
      <span>{{menuNa}}</span>
      <i class="imgBox"><img src="../../assets/img/gtIocn.png" alt=""></i>
      <span>{{menuTabsValue}}</span>
    </div>
  </div>
  <div class="right">
    <div class="userMess">
      <ul>
        <li v-if="toScreenShow" class="toScreenBtn" title="进入大屏" @click="toScreen">
          <i class="screenNew">
            <img src="../../assets/img/topHomepage.png" alt="">
          </i>
        </li>
        <li class="reset" title="刷新当前页面" @click="refresh()"><i><img src="../../assets/img/reset.png" alt=""></i></li>
        <li title="用户信息" class="adminMess" :class="isShow?'active':''">
          <el-popover placement="bottom" title="" width="160" trigger="click" @show="showMess" @hide="hideMess">
            <div class="detail">
              <!-- <div class="title">
                <i class="imgBox">
                  <img :src="imgPath" alt />
                </i>
                <span>{{loginName}}</span>
              </div> -->
              <div class="mess">
                <p class="p1">昵称：{{nickName?nickName:''}}</p>
                <p class="p2">组织：{{orgName?orgName:'无'}}</p>
                <p class="p3" @click="logOut">
                  <i><img src="../../assets/img/ccloseBtn.png" alt=""></i>
                  <span>退出账号</span>
                </p>
              </div>
            </div>
            <div slot="reference" class="userM">
              <i class="imgs">
                <img :src="imgPath" alt="">
              </i>
              <span class="loginName">{{loginName}}</span>
              <i class="upDown">
                <img src="../../assets/img/downOrUp.png" alt="">
              </i>
            </div>
          </el-popover>
        </li>
        <!-- <li title="退出" @click="logOut()"><i class="close"><img src="../../assets/img/topClose.png" alt=""></i></li> -->
      </ul>
    </div>
  </div>
</div>
</template>

<script>
import bus from '@/bus/bus';
export default {
  inject: ["reload"],
  data() {
    return {
      toScreenShow: false,
      openClose: false,
      sysName: '',
      loginName: this.storage.getSession("loginName") ? this.storage.getSession("loginName") : '',
      imgPath: this.storage.getSession("tenant") ? require('../../assets/img/admin.png') : require('../../assets/img/user.png'),
      nickName: this.storage.getSession("nickName") ? this.storage.getSession("nickName") : '无',
      orgName: this.storage.getSession("orgName") ? this.storage.getSession("orgName") : '无',
      menuTabs: [],
      menuList:[],
      menuTabsValue: "",
      tabsMenu: [],
      sendMess:false,
      menuNa:'',
      newmenuNa:'',
      newName:'',
      isShow:false
    };
  },
  created() {
    // console.log(sessionStorage.getItem('privileges').indexOf('home:show'))
    // this.toScreenShow = sessionStorage.getItem('privileges').indexOf('home:show') != -1 ? true : false
    this.toScreenShow = sessionStorage.getItem('tenant') ? true : false
    this.getMenuData()
  },
  mounted() {
    bus.$on('changeSysname', e => {
      this.sysName = e
      document.title = e
    })
  },
  watch:{
    menuNameNew(curval, oldval){
      // console.log(888,curval);
      this.newName = curval.name
    },
    menuName(curval, oldval) {
      // console.log(curval);
      // console.log(oldval);
      this.fiterChildren(curval)
      // console.log(this.sendMess);
      if(this.sendMess){
        this.menuNa = curval.name
      } else {
        this.newmenuNa = curval.name
      }
      // console.log(this.menuNa);
    },
    $route(nV, oV) {
      this.newName = ''
      if(this.newmenuNa&&!this.sendMess){
        this.menuNa = this.newmenuNa
      } else {
        this.newmenuNa = ''
      }
      // console.log(nV);
      // console.log(this.tabsMenu);
      let tabsMenu = this.tabsMenu;
      tabsMenu.forEach((tv, j) => {
        if (tv.componentUrl == nV.path) {
          this.menuTabsValue = tabsMenu[j].name;
        }
      })
    }
  },
  computed:{
    menuName(){
      return this.$store.state.menuName
    },
    menuNameNew(){
      return this.$store.state.menuNameNew
    }
  },
  methods: {
    showMess(){
      this.isShow = true 
    },
    hideMess(){
      this.isShow = false
    },
    fiterChildren(param){
      let flag = true
      if (param.children != null) {
        param.children.forEach(value => {
          if ('/' + this.$route.name == value.componentUrl) {
            // console.log(444);
            flag = false 
            this.sendMess = true
          }
          if(flag){
            if(value.children!= null){
              flag = false
            //   console.log(666);
              this.fiterChildren(value)
            }
          }
        })
      }
      // console.log(flag);
      if(flag){
        this.sendMess = false
      }
    },
    refresh() { //刷新
      this.$router.go(0)
    },
    toScreen() {
      const {
        href
      } = this.$router.resolve({
        name: 'Screen'
      })
      window.open(href, "_blank")
    },
    logOut() {
      // this.$router.push("./login")
      //用户退出登录
      this.$confirm("是否退出该账户?", "退出登录提示", {
          confirmButtonText: "退出",
          cancelButtonText: "取消",
          type: "error",
          center: true
        })
        .then(() => {
          this.request.get("/front/auth/logout").then((data) => {
            // console.log(data);
            // debugger
            if (data.code == 200) {
              this.msg.success("退出登录成功！");
              // sessionStorage.setItem('alarmList', null)
              this.resetSetItem('alarmList', null)
              this.storage.setSession("login", false);
              // 清console.log()除session
              sessionStorage.removeItem("orgName");
              sessionStorage.removeItem("orgId");
              // sessionStorage.removeItem("userName");
              // sessionStorage.removeItem("password");
              sessionStorage.removeItem("headImg");
              sessionStorage.removeItem("userId");
              sessionStorage.removeItem("privileges");
              // sessionStorage.removeItem("nickname");
              sessionStorage.removeItem("sysTab");
              sessionStorage.removeItem("sysStartTime")
              sessionStorage.removeItem("modelId")
              this.$router.push("/login");
            } else if (data.code == 500) {
              // this.msg.error(data.msg);
              if (data.msg) {
                this.msg.warn("退出登录失败，请联系管理员！");
              } else {
                this.msg.warn("Session过期，请重新登录!")
                this.$router.push("/login");
              }
            }
          });
        })
        .catch(() => {
          this.msg.info("已取消退出登录");
        });
    },
    getMenuData() {
      // console.log(this.$route);
      this.request
        .get("/front/system/module/query/tree")
        .then((res) => {
          //左侧菜单
          // console.log(res);
          if (res.code == 200) {
            this.menuList=res.data           
            this.menuList.forEach((val) => {
              if(val.children!=null){
                val.children.forEach(item=>{
                  this.tabsMenu.push(item)
                  if(item.children!=null) {
                    item.children.forEach(item2 => {
                      this.tabsMenu.push(item2)
                    })
                  }
                })
              }else{
                this.tabsMenu.push(val)
              }
            });
            // console.log(this.tabsMenu)
            // console.log(this.$route.name)
            this.tabsMenu.forEach((v, i) => {
              if (v.componentUrl == '/'+this.$route.name) {
                this.menuTabs.push(this.tabsMenu[i]);
                this.menuTabsValue = this.tabsMenu[i].name;
              }
            });
          } else if (res.code == 500) {
            this.msg.warn(res.msg)
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //  homePage(){
    //      // 跳转至首页
    //     if(this.storage.getSession('modelId')){
    //        this.$router.push('/homePageN')
    //     }else{
    //        this.$router.push('/homeIndex')
    //     }
    //  },
  }
};
</script>

<style lang="scss" scoped>
.topAsideContainer {
  // border: 1px solid red;
  width: 100%;
  height: 44px;
  overflow: hidden;
  font-size: 0;
  padding: 5px 10px 5px 0;
  color: #33383E;
  background-color: #fff;
  border-bottom:1px solid #ebeef5;

  .left {
    float: left;
    overflow: hidden;
    margin-left: 20px;
    .logo {
      float: left;
      position: relative;
      // cursor: pointer;
      overflow: hidden;
      span {
        float: left;
        font-size: 18px;
        font-weight: 500;
        color: #33383E;
        line-height: 44px;
        font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
      }
      i{
        float: left;
        width: 14px;
        height: 14px;
        margin: 15px 3px 0;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .right {
    float: right;
    overflow: hidden;
    margin-right: 20px;
    font-size: 0;
    .userMess {     
      ul {
        overflow: hidden;

        li {
          float: left;
          cursor: pointer;
          box-sizing: border-box;

          i {
            display: inline-block;
            width: 16px;
            height: 16px;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .imgs {
            width: 24px;
            height: 24px;
          }

          .close {
            width: 26px;
            height: 26px;
          }

          &:hover {
            
          }
        }
        .toScreenBtn {
          color: #33383E;
          text-align: center;
          width: 44px;
          height: 44px;
          background-color: #fff;
          border-radius: 2px;
          .screenNew {
            margin-top: 14px;
            img{
              vertical-align: unset;
            }
          }
        }
        .reset{
          text-align: center;
          width: 44px;
          height: 44px;
          background-color: #fff;
          border-radius: 2px;
          margin-left: 10px;
          i{
            margin-top: 14px;
          }
        }
        .adminMess{
          margin-left: 10px;
          width: 160px;
          height: 43px;
          background: #FFFFFF;
          border-radius: 2px;
          box-sizing: border-box;
          overflow: hidden;
          border:1px solid #fff;
          &:hover{
            border: 1px solid #1089FF;
          }
          &.active{
            border: 1px solid #1089FF;
          }
          .userM{
            width: 100%;
            height: 100%;
          }
          .imgs{
            float: left;
            width: 34px;
            height: 34px;
            margin: 4px 0 0 5px;
          }
          .loginName {
            width: 90px;
            float: left;
            font-size: 14px;
            font-weight: bold;
            color: #33383E;
            line-height: 44px;
          }
          .upDown{
            float: right;
            width: 24px;
            height: 44px;
            overflow: hidden;
            img{
              width: 14px;
              height: 14px;
              margin:14px 10px 0 0;
            }
          }
        }
      }
    }
  }
}

.detail {
  padding:10px;

  .title {
    overflow: hidden;

    i {
      float: left;
      width: 40px;
      height: 40px;

      img {
        vertical-align: top;
      }
    }

    span {
      float: left;
      margin-left: 14px;
      margin-top: 10px;
      font-size: 16px;
      font-weight: 500;
      color: #4f81bd;
    }
  }

  .mess {
    p {
      line-height: 20px;
      margin-bottom: 10px;
    }

    .p1 {
      line-height: 20px;
      font-size: 14px;
      color: 33383E;
    }

    .p2 {
      line-height: 20px;
      color: 33383E;
      font-size: 14px;
    }

    .p3 {
      cursor: pointer;
      overflow: hidden;
      i{
        float: left;
        width: 14px;
        height: 14px;
        margin-left: 40px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      span{
        margin-left: 5px;
        float: left;
        font-size: 14px;
        color: #1089FF;
      }
    }
  }
}
</style><style lang="scss">
.topAsideContainer {
  .right {
    .searchCons {
      .el-input {
        float: left;
        margin-right: 30px;
        margin-top: 14px;
        width: 220px;
      }
    }
  }
}
.el-popper[x-placement^=bottom]{
  margin-top: 6px !important;
  padding: 0 !important;
}
</style>
